goog.provide("shadow.js.shim.module$src$svg$devices$smartphone_gen_2_svg");
goog.provide("module$shadow_js_shim_module$src$svg$devices$smartphone_gen_2_svg");
shadow.js.shim.module$src$svg$devices$smartphone_gen_2_svg = shadow.js.nativeProvides["src/svg/devices/smartphone-gen-2.svg"] = shadow$bridge("src/svg/devices/smartphone-gen-2.svg");
module$shadow_js_shim_module$src$svg$devices$smartphone_gen_2_svg.default = shadow.js.shim.module$src$svg$devices$smartphone_gen_2_svg;
